import React, {useEffect, useState} from 'react';
import { withStyles } from "@mui/styles";
import {Dialog, DialogContent, DialogTitle, IconButton, Typography} from '@mui/material';
import {connect} from "trim-redux";
import {useTranslation} from "react-i18next";
import {Close} from "@mui/icons-material";
import {Styles} from "../../../../config/design/styles";
import Button from "@mui/material/Button";
import {ChevronRight, Pencil, Star} from "lucide-react";
import Grid from "@mui/material/Grid2";
import LoadingButton from "../../../components/elements/LoadingButton";
import axios from "axios";
import {defaultVariables} from "../../../../config";
import RayaField from "../../../components/elements/fields/RayaField";
import {Rating} from "@mui/lab";
import AddBox from "@mui/icons-material/AddBox";
import {Link} from "react-router-dom";
import {truncate} from "../../../../config/values";

function MakeCommentButtonManage({item_id,item,classes,reload }) {
    const { t } = useTranslation();
    const [open,setOpen] = useState(false);
    const [comment,setComment] = useState(item.comment);
    const [rate,setRate] = useState(item.rate);
    const [submitLoading, setSubmitLoading] = useState(false);
    useEffect(() => {
        setComment(item.comment);
        setRate(item.rate);

    }, [item]);
    const handleRequest = async () => {
        setSubmitLoading(true);
        const data = new FormData();
        data.append('id', item_id);
        data.append('rate', rate);
        data.append('comment', comment);

        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            const response = await axios.post(`${defaultVariables.url}/comments/edit`, data, config);
            setSubmitLoading(false);
            reload(response.data);
            setOpen(false);
        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);

        }
    }
    return (
        <>

            <Button
                onClick={() => setOpen(true)}
                startIcon={!!item_id ? <Pencil className="lucide-icon-secondary btn"/> : <AddBox/>}
                color="secondary"
                variant="outlined"
            >
                {t('edit')}
            </Button>
            <Dialog  open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
                <DialogTitle>
                    {t('editComment')}
                    <IconButton
                        onClick={() => setOpen(false)}
                        style={{position:"absolute",right:15,top:15}}
                        size="small"
                    >
                        <Close className="lucide-icon"/>
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} style={{padding:10}}>
                        <Grid item size={12}>
                            <div className="comment-products">
                                {
                                    item.products?.map((product, index) => (
                                        <span key={index}>
                                    <Link to={`/panel/manage/products/edit/${product.id}`}>
                                      {product?.name}
                                    </Link>
                                  </span>
                                    ))
                                }
                            </div>
                        </Grid>
                        <Grid item size={12} style={{textAlign:"center"}}>
                            <Rating
                                precision={1}
                                value={rate}
                                size="large"
                                onChange={(event, newValue) => {
                                    setRate(newValue);
                                }}
                            />
                        </Grid>
                        <Grid item size={12}>
                            <RayaField
                                variant="outlined"
                                multiline
                                fullWidth
                                name="comment"
                                label={t('comment')}
                                type="text"
                                rows="4"
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                            />
                        </Grid>

                        <Grid item size={12}>
                            <LoadingButton
                                className="confirm-btn"
                                variant="contained"
                                onClick={() => handleRequest()}
                                loading={submitLoading}
                            >
                                {t("edit")}
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </>

    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
});

export default withStyles(Styles)(connect(mapStateToProps)(MakeCommentButtonManage));
